import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HomeScreen from "./components/HomeScreen";
import Register from "./components/Register";
import UpdateProfile from "./components/UpdateProfile";
import Login from "./components/Login";
import ImageUploadModal from "./components/ImageUploadModal";
import ReportLocationModal from "./components/ReportLocationModal";
import VendorUploadPage from "./components/VendorUploadPage";
// import AdminPanel from "./components/AdminPanel"; // legacy modal, not used
import AdminPage from "./components/AdminPage";
import laari from "./assets/logo_cropped.png";
import laariGreen from "./assets/logo_cropped_green.png";
import logo from "./assets/logo.png";
import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./App.css";
import usePageTracking from './usePageTracking';
import api, { normalizeVendor, Review } from './api/client';
import { trackVendorClick } from './utils/vendorClickTracker';


import ReactGA from 'react-ga4';

ReactGA.initialize('G-ZC8J75N781'); // Your GA4 Measurement ID

interface OperatingHours {
  openTime: string; // Format: "HH:mm" in 24-hour format
  closeTime: string; // Format: "HH:mm" in 24-hour format
  days: number[]; // 0-6 representing Sunday-Saturday
}

interface Vendor {
  _id: string;
  name?: string;
  businessName?: string;
  vendorName?: string;
  vendorType?: "street_vendor" | "tiffin_maker";
serviceAreas?: string[];
deliveryAvailable?: boolean;
mealTypes?: string[];

mealTimings?: {
  breakfast: {
    available: boolean;
    startTime: string | null;
    endTime: string | null;
  };
  lunch: {
    available: boolean;
    startTime: string | null;
    endTime: string | null;
  };
  dinner: {
    available: boolean;
    startTime: string | null;
    endTime: string | null;
  };
};

contactNumber: string;
  email?: string;
  mapsLink?: string;
  operatingHours?: any;
  updatedAt?: string;
  foodType?: 'veg' | 'non-veg' | 'swaminarayan' | 'jain' | 'none';
  profilePictures?: string[];
  carouselImages?: string[];
  bestDishes?: Array<{ name: string; price?: number; menuLink?: string }>;
  latitude?: number;
  longitude?: number;
  area?: string; // Add area field for vendor location
  location?: { area?: string; coordinates?: number[] }; // Add location field for vendor location
  category?: string[]; // Add category field for food categories
}

// Define food categories
const FOOD_CATEGORIES = [
  'Chaat',
  'Juices',
  'Tea/Coffee',
  'Snacks',
  'Desserts & Beverages',
  'Gujju Snacks',
  'Pav Bhaji',
  'Punjabi',
  'Pizza',
  'Burger',
  'Korean',
  'Chinese',
  'South Indian',
  'Other'
];

const FOOD_TYPES = ['veg', 'non-veg', 'swaminarayan', 'jain'];

// Filter interface
interface FilterState {
  foodTypes: string[];
  categories: string[];
}

// Define area boundaries for Ahmedabad and Gandhinagar localities
const AREA_BOUNDARIES: { [key: string]: { lat: number; lng: number; zoom: number } } = {
  // Ahmedabad
  'navrangpura': { lat: 23.0425, lng: 72.5586, zoom: 15 },
  'ellis bridge': { lat: 23.0258, lng: 72.5714, zoom: 15 },
  'paldi': { lat: 23.0120, lng: 72.5597, zoom: 15 },
  'maninagar': { lat: 22.9957, lng: 72.6031, zoom: 15 },
  'vastrapur': { lat: 23.0406, lng: 72.5151, zoom: 15 },
  'satellite': { lat: 23.0307, lng: 72.5151, zoom: 15 },
  'bopal': { lat: 23.0300, lng: 72.4647, zoom: 14 },
  'bodakdev': { lat: 23.0587, lng: 72.5072, zoom: 15 },
  'thaltej': { lat: 23.0702, lng: 72.5077, zoom: 15 },
  'gota': { lat: 23.1023, lng: 72.5417, zoom: 14 },
  'chandkheda': { lat: 23.1122, lng: 72.5797, zoom: 14 },
  'motera': { lat: 23.1046, lng: 72.5952, zoom: 15 },
  'sabarmati': { lat: 23.0736, lng: 72.5802, zoom: 15 },
  'naranpura': { lat: 23.0680, lng: 72.5617, zoom: 15 },
  'memnagar': { lat: 23.0626, lng: 72.5462, zoom: 15 },
  'ambawadi': { lat: 23.0225, lng: 72.5487, zoom: 15 },
  'vasna': { lat: 23.0067, lng: 72.5462, zoom: 15 },
  'jodhpur': { lat: 23.0262, lng: 72.5151, zoom: 15 },
  'prahlad nagar': { lat: 23.0225, lng: 72.5017, zoom: 15 },
  'shyamal': { lat: 23.0250, lng: 72.5300, zoom: 15 },
  'anandnagar': { lat: 23.0275, lng: 72.5400, zoom: 15 },
  'gheekanta': { lat: 23.0300, lng: 72.5800, zoom: 15 },
  'kalupur': { lat: 23.0286, lng: 72.6029, zoom: 15 },
  'saraspur': { lat: 23.0380, lng: 72.6130, zoom: 15 },
  'asara': { lat: 23.0400, lng: 72.6000, zoom: 15 },
  'naroda': { lat: 23.0896, lng: 72.6677, zoom: 14 },
  'odhav': { lat: 23.0330, lng: 72.6690, zoom: 14 },
  'vatva': { lat: 22.9580, lng: 72.6420, zoom: 14 },
  'iscon': { lat: 23.0300, lng: 72.4950, zoom: 15 },
  'sarkhej': { lat: 22.9910, lng: 72.5010, zoom: 14 },
  'juhapura': { lat: 23.0080, lng: 72.5240, zoom: 14 },
  'vastral': { lat: 23.0330, lng: 72.6850, zoom: 14 },
  'nikol': { lat: 23.0450, lng: 72.6700, zoom: 14 },
  'bapunagar': { lat: 23.0330, lng: 72.6250, zoom: 15 },
  'amraiwadi': { lat: 23.0130, lng: 72.6350, zoom: 15 },
  'ranip': { lat: 23.0800, lng: 72.5700, zoom: 15 },
  'gandhinagar': { lat: 23.2230, lng: 72.6500, zoom: 13 },
  // Gandhinagar
  'sector 1': { lat: 23.2230, lng: 72.6500, zoom: 15 },
  'sector 2': { lat: 23.2250, lng: 72.6520, zoom: 15 },
  'sector 3': { lat: 23.2270, lng: 72.6540, zoom: 15 },
  'sector 4': { lat: 23.2290, lng: 72.6560, zoom: 15 },
  'sector 5': { lat: 23.2310, lng: 72.6580, zoom: 15 },
  'sector 6': { lat: 23.2330, lng: 72.6600, zoom: 15 },
  'sector 7': { lat: 23.2350, lng: 72.6620, zoom: 15 },
  'sector 8': { lat: 23.2370, lng: 72.6640, zoom: 15 },
  'sector 9': { lat: 23.2390, lng: 72.6660, zoom: 15 },
  'sector 10': { lat: 23.2410, lng: 72.6680, zoom: 15 },
  'sector 11': { lat: 23.2430, lng: 72.6700, zoom: 15 },
  'sector 12': { lat: 23.2450, lng: 72.6720, zoom: 15 },
  'sector 13': { lat: 23.2470, lng: 72.6740, zoom: 15 },
  'sector 14': { lat: 23.2490, lng: 72.6760, zoom: 15 },
  'sector 15': { lat: 23.2510, lng: 72.6780, zoom: 15 },
  'sector 16': { lat: 23.2530, lng: 72.6800, zoom: 15 },
  'sector 17': { lat: 23.2550, lng: 72.6820, zoom: 15 },
  'sector 18': { lat: 23.2570, lng: 72.6840, zoom: 15 },
  'sector 19': { lat: 23.2590, lng: 72.6860, zoom: 15 },
  'sector 20': { lat: 23.2610, lng: 72.6880, zoom: 15 },
  'sector 21': { lat: 23.2630, lng: 72.6900, zoom: 15 },
  'sector 22': { lat: 23.2650, lng: 72.6920, zoom: 15 },
  'sector 23': { lat: 23.2670, lng: 72.6940, zoom: 15 },
  'sector 24': { lat: 23.2690, lng: 72.6960, zoom: 15 },
  'sector 25': { lat: 23.2710, lng: 72.6980, zoom: 15 },
  'sector 26': { lat: 23.2730, lng: 72.7000, zoom: 15 },
  'sector 27': { lat: 23.2750, lng: 72.7020, zoom: 15 },
  'sector 28': { lat: 23.2770, lng: 72.7040, zoom: 15 },
  'sector 29': { lat: 23.2790, lng: 72.7060, zoom: 15 },
  'sector 30': { lat: 23.2810, lng: 72.7080, zoom: 15 },
  'infocity': { lat: 23.2040, lng: 72.6369, zoom: 15 },
  'gift city': { lat: 23.1568, lng: 72.6835, zoom: 15 },
  'kudasan': { lat: 23.2000, lng: 72.6500, zoom: 15 },
  'chiloda': { lat: 23.2500, lng: 72.7000, zoom: 15 },
  'sargasan': { lat: 23.2100, lng: 72.6200, zoom: 15 },
  'adraj mota': { lat: 23.3000, lng: 72.7000, zoom: 15 },
  'randesan': { lat: 23.2200, lng: 72.7100, zoom: 15 },
  'vavol': { lat: 23.2300, lng: 72.7200, zoom: 15 },
  'pethapur': { lat: 23.2800, lng: 72.7300, zoom: 15 },
  'kolavada': { lat: 23.2900, lng: 72.7400, zoom: 15 },
  'zundal': { lat: 23.1800, lng: 72.6700, zoom: 15 },
  'chhatral': { lat: 23.3300, lng: 72.7800, zoom: 15 },
  // Add more localities as needed
};

function MapDisplay() {
  const mapRef = useRef<L.Map | null>(null);
  const markersRef = useRef<{ [key: string]: L.Marker }>({});
  const userLocationMarkerRef = useRef<L.Marker | null>(null);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [filteredVendors, setFilteredVendors] = useState<Vendor[]>([]); // Add filtered vendors state
  const [error, setError] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<{
    latitude: number;
    longitude: number;
  } | null>(null);
  const [currentZoom, setCurrentZoom] = useState<number>(13);
  const [isMapInitialized, setIsMapInitialized] = useState<boolean>(false);
  const [isLocationLoading, setIsLocationLoading] = useState<boolean>(true);
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [isVendorCardVisible, setIsVendorCardVisible] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]); // Change to any[] to support different result types
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showError, setShowError] = useState(true);
  const [reviews, setReviews] = useState<Review[]>([]);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [reviewForm, setReviewForm] = useState({ name: '', email: '', rating: 0, comment: '' });
  const [submitting, setSubmitting] = useState(false);
  const [reviewError, setReviewError] = useState<string | null>(null);
  const [auth ] = useState<{ name: string; email: string } | null>(() => {
    const name = localStorage.getItem('lk_auth_name');
    const email = localStorage.getItem('lk_auth_email');
    const token = localStorage.getItem('lk_auth_token');
    return name && email && token ? { name, email } : null;
  });

  // Filter states
  const [activeFilters, setActiveFilters] = useState<FilterState>({
    foodTypes: [],
    categories: []
  });
  const [showFilters, setShowFilters] = useState(false);
  const [showOnlyOpen, setShowOnlyOpen] = useState(false);

  // Image upload modal states
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [uploadType, setUploadType] = useState<'profile' | 'carousel'>('profile');

  // Report location modal states
  const [showReportModal, setShowReportModal] = useState(false);

  // Carousel state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [carouselInterval, setCarouselInterval] = useState<NodeJS.Timeout | null>(null);

  // Touch/swipe functionality for carousel
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  // Responsive state for screen size
  const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(false);

  const navigate = useNavigate();
  const formatTime = (time?: string | null) => {
  if (!time) return "";

  // Remove "(flexible)" but remember whether it existed
  const isFlexible = time.includes("(flexible)");
  const cleanTime = time.replace(/\s*\(flexible\)/i, "").trim();

  const [hourStr, minute = "00"] = cleanTime.split(":");
  let hour = parseInt(hourStr, 10);

  const suffix = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  if (hour === 0) hour = 12;

  return `${hour}:${minute} ${suffix}${isFlexible ? " (Flexible)" : ""}`;
  };


  // Auto-rotation for carousel
  useEffect(() => {
    if (selectedVendor?.carouselImages && selectedVendor.carouselImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex(prev => 
          prev >= selectedVendor.carouselImages!.length - 1 ? 0 : prev + 1
        );
      }, 3000);

      setCarouselInterval(interval);

      return () => {
        if (interval) clearInterval(interval);
      };
    } else {
      setCurrentImageIndex(0);
      if (carouselInterval) {
        clearInterval(carouselInterval);
        setCarouselInterval(null);
      }
    }
  }, [selectedVendor?.carouselImages]);

  // Reset carousel index when vendor changes
  useEffect(() => {
    setCurrentImageIndex(0);
  }, [selectedVendor?._id]);

  // Detect screen size changes for responsive behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup event listener
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Single source of truth for whether any filter is active
  const hasActiveFilters =
     activeFilters.foodTypes.length > 0 ||
     activeFilters.categories.length > 0 ||
     showOnlyOpen;

// Filter vendors based on active filters and open status
    const applyFilters = (
    vendorList: Vendor[],
    filters = activeFilters
   ) => {
    let filteredVendors = vendorList;

    // Apply open/closed filter first
    if (showOnlyOpen) {
      filteredVendors = filteredVendors.filter(vendor => {
        const { status } = getOperatingStatus(vendor.operatingHours);
        return status === 'Open Now';
      });
    }

    // Apply food type and category filters
    if (filters.foodTypes.length === 0 && filters.categories.length === 0) {
      return filteredVendors; // No additional filters applied, return filtered vendors
    }

    console.log('Applying filters:', filters);
    console.log('Vendors to filter:', filteredVendors.length);

    return filteredVendors.filter(vendor => {
      // Check food type filter
      const normalizedVendorFoodType = (vendor.foodType || '')
     .toLowerCase()
     .replace(/[\s-]/g, '');

    const foodTypeMatch =
    filters.foodTypes.length === 0 ||
    filters.foodTypes.some(filter =>
    filter.toLowerCase().replace(/[\s-]/g, '') === normalizedVendorFoodType
     );

      // Check category filter - use the category field that's now set by normalizeVendor
      const categoryMatch = filters.categories.length === 0 ||
  (vendor.category && vendor.category.some((cat: string) => filters.categories.includes(cat)));

      // Debug: Log vendor filtering details
      if (filters.categories.length > 0) {
        console.log(`Vendor ${vendor.name}:`, {
          categories: vendor.category,
          categoryMatch,
          foodTypeMatch,
          passes: foodTypeMatch && categoryMatch
        });
      }

      return foodTypeMatch && categoryMatch;
    });
  };

  // Handle filter changes
  const handleFilterChange = (filterType: 'foodTypes' | 'categories', value: string) => {
    setActiveFilters(prev => {
      const currentFilters = prev[filterType];
      let newFilters: string[];
      
      // Single selection: if the clicked value is already selected, deselect it
      // Otherwise, replace the current selection with the new one
      if (currentFilters.includes(value)) {
        newFilters = currentFilters.filter(item => item !== value);
      } else {
        newFilters = [value]; // Only allow one selection at a time
      }

      const updatedFilters = {
        ...prev,
        [filterType]: newFilters
      };

      // Apply filters immediately
      const filtered = applyFilters(vendors, updatedFilters);
      setFilteredVendors(filtered);

      return updatedFilters;
    });
  };

  // Clear all filters
  const clearAllFilters = () => {
    setActiveFilters({
      foodTypes: [],
      categories: []
    });
    setShowOnlyOpen(false);
    setFilteredVendors([]);
  };

  // Helper function to convert time string to minutes from midnight (supports 24-hour and 12-hour AM/PM)
  const convertToMinutes = (timeStr: string): number => {
    // Try 24-hour format first
    let match = timeStr.match(/^\s*(\d{1,2}):(\d{2})\s*$/);
    if (match) {
      const hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      return hours * 60 + minutes;
    }
    // Try 12-hour format with AM/PM
    match = timeStr.match(/^\s*(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (match) {
      let hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      const period = match[3].toUpperCase();
      if (period === 'PM' && hours !== 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;
      return hours * 60 + minutes;
    }
    return 0; // fallback
  };

  const getOperatingStatus = (operatingHours?: OperatingHours) => {
    if (!operatingHours || !operatingHours.openTime || !operatingHours.closeTime || !operatingHours.days || operatingHours.days.length === 0) {
      return { status: 'Hours Not Specified', color: '#888' };
    }

    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 6 = Saturday
    const yesterdayDay = (currentDay - 1 + 7) % 7; // The day before today
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const openTimeInMinutes = convertToMinutes(operatingHours.openTime);
    const closeTimeInMinutes = convertToMinutes(operatingHours.closeTime);

    let isOpen = false;
    // Case 1: Overnight schedule (e.g., 22:00 - 02:00)
    if (closeTimeInMinutes < openTimeInMinutes) {
      // Overnight: openTime (e.g., 19:00) to 23:59 today, and 00:00 to closeTime tomorrow
      if (
        (currentMinutes >= openTimeInMinutes && operatingHours.days.includes(currentDay)) ||
        (currentMinutes <= closeTimeInMinutes && operatingHours.days.includes(yesterdayDay))
      ) {
        isOpen = true;
      }
    }
    // Case 2: Same-day schedule
    else {
      if (currentMinutes >= openTimeInMinutes && currentMinutes <= closeTimeInMinutes && operatingHours.days.includes(currentDay)) {
        isOpen = true;
      }
    }

    if (!isOpen) {
      return { status: 'Closed', color: '#d9534f' };
    }

    // If open, check if it's closing soon
    const closesSoonThreshold = 30; // minutes
    let timeUntilClose;
    if (closeTimeInMinutes < openTimeInMinutes) {
      // Overnight: calculate time until close correctly
      if (currentMinutes >= openTimeInMinutes) {
        // Before midnight
        timeUntilClose = (closeTimeInMinutes + 1440) - currentMinutes;
      } else {
        // After midnight
        timeUntilClose = closeTimeInMinutes - currentMinutes;
      }
    } else {
      timeUntilClose = closeTimeInMinutes - currentMinutes;
    }
    if (timeUntilClose > 0 && timeUntilClose <= closesSoonThreshold) {
      return { status: 'Closes Soon', color: '#f0ad4e' };
    }

    return { status: 'Open Now', color: '#28a745' };
  };

  // Alternative: IP-based location fallback
  const getLocationFromIP = async () => {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      
      if (data.latitude && data.longitude) {
        return {
          latitude: data.latitude,
          longitude: data.longitude
        };
      }
    } catch (error) {
      console.error('IP location failed:', error);
    }
    return null;
  };

  // Simplified getUserLocation with better error handling
  const getUserLocation = async () => {
    setIsLocationLoading(true);
    
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by this browser");
      setError("Geolocation is not supported by your browser. Using default view.");
      setIsLocationLoading(false);
      return;
    }

    try {
      // Try browser geolocation first
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: false, // Set to false to avoid 429 errors
            timeout: 10000,
            maximumAge: 600000 // 10 minutes cache
          }
        );
      });

      const userCoords = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      
      console.log("User location obtained:", userCoords);
      setUserLocation(userCoords);
      setError(null);
      setIsLocationLoading(false);
      return;

    } catch (geolocationError: any) {
      console.log("Browser geolocation failed, trying IP location...", geolocationError);
      
      // Fallback to IP-based location
      try {
        const ipLocation = await getLocationFromIP();
        if (ipLocation) {
          console.log("Using IP-based location:", ipLocation);
          setUserLocation(ipLocation);
          setError("Using approximate location based on your IP address.");
        } else {
          console.log("IP location also failed, using default location");
          setError("Could not determine your location. Using default view.");
        }
      } catch (ipError) {
        console.error("IP location also failed:", ipError);
        setError("Could not determine your location. Using default view.");
      }
      
      setIsLocationLoading(false);
    }
  };

  // Helper function to validate coordinates are in Ahmedabad/Gandhinagar area
  const isValidAhmedabadCoordinate = (latitude: number, longitude: number): boolean => {
    // Ahmedabad/Gandhinagar area bounds
    const MIN_LAT = 22.5;  // South boundary
    const MAX_LAT = 23.5;  // North boundary
    const MIN_LNG = 72.0;  // West boundary
    const MAX_LNG = 73.0;  // East boundary
    
    const isValid = latitude >= MIN_LAT && latitude <= MAX_LAT && 
                   longitude >= MIN_LNG && longitude <= MAX_LNG;
    
    if (!isValid) {
      console.warn(`Invalid coordinates for Ahmedabad/Gandhinagar: ${latitude}, ${longitude}`);
      console.warn(`Expected range: Lat ${MIN_LAT}-${MAX_LAT}, Lng ${MIN_LNG}-${MAX_LNG}`);
    }
    
    return isValid;
  };

  const extractCoordinates = (mapsLink: string | undefined | null) => {
    // Check if mapsLink exists and is a string
    if (!mapsLink || typeof mapsLink !== 'string') {
      return null;
    }
    
    try {
      console.log("Attempting to extract coordinates from:", mapsLink);

      // Pattern 1: @lat,lng,zoom (most common format)
      let match = mapsLink.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (match) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        
        // Validate coordinates are in Ahmedabad/Gandhinagar area
        if (isValidAhmedabadCoordinate(latitude, longitude)) {
          const coords = { latitude, longitude };
          console.log("Extracted coordinates from @lat,lng:", coords);
          return coords;
        } else {
          console.warn("Coordinates outside Ahmedabad/Gandhinagar area:", { latitude, longitude });
          return null;
        }
      }

      // Pattern 2: !3d...!4d... (alternate format)
      match = mapsLink.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
      if (match) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        
        if (isValidAhmedabadCoordinate(latitude, longitude)) {
          const coords = { latitude, longitude };
          console.log("Extracted coordinates from !3d...!4d...:", coords);
          return coords;
        } else {
          console.warn("Coordinates outside Ahmedabad/Gandhinagar area:", { latitude, longitude });
          return null;
        }
      }

      // Pattern 3: place/.../@lat,lng
      match = mapsLink.match(/place\/.*\/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (match) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        
        if (isValidAhmedabadCoordinate(latitude, longitude)) {
          const coords = { latitude, longitude };
          console.log("Extracted coordinates from place/@lat,lng:", coords);
          return coords;
        } else {
          console.warn("Coordinates outside Ahmedabad/Gandhinagar area:", { latitude, longitude });
          return null;
        }
      }

      // Pattern 4: q=lat,lng
      match = mapsLink.match(/q=(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (match) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        
        if (isValidAhmedabadCoordinate(latitude, longitude)) {
          const coords = { latitude, longitude };
          console.log("Extracted coordinates from q=lat,lng:", coords);
          return coords;
        } else {
          console.warn("Coordinates outside Ahmedabad/Gandhinagar area:", { latitude, longitude });
          return null;
        }
      }

      console.error("No valid coordinates found in URL");
      return null;
    } catch (error) {
      console.error("Error extracting coordinates:", error);
      return null;
    }
  };

  const fetchVendors = async () => {
    try {
      const result = await api.getAllUsers();
      
      if (result.success && result.data) {
        // Normalize all vendors to ensure latitude/longitude fields
        const normalized = result.data.map(normalizeVendor);
        
        // console.log(
        // normalized.map(v => ({
        // name: v.name,
        // vendorType: v.vendorType
        // }))
        // );

        console.log(
        "API returned tiffin makers:",
        result.data.filter((v: any) => v.vendorType === "tiffin_maker").length
        );

        console.log(
         "Normalized tiffin makers:",
         normalized.filter((v: any) => v.vendorType === "tiffin_maker").length
         );



        // Filter out vendors without valid latitude/longitude
        const withLocation = normalized.filter(v => typeof v.latitude === 'number' && typeof v.longitude === 'number');
        
        console.log(
        "With-location tiffin makers:",
        withLocation.filter((v: any) => v.vendorType === "tiffin_maker").length
        );

        console.log(
        "Tiffin makers on map:",
        withLocation.filter(v => (v as any).vendorType === "tiffin_maker").length
      );

        console.log(
        (withLocation.filter(v => (v as any).vendorType === "tiffin_maker")).slice(0, 10)
      );
        
        setVendors(withLocation);
        console.log("Vendors set successfully:", withLocation.length, "vendors");
        return withLocation;
      } else {
        console.error("API response indicates failure:", result.error);
        setError(result.error || "Failed to fetch vendors data");
        return [];
      }
    } catch (error: unknown) {
      console.error("Error fetching vendors:", error);
      setError(`Failed to fetch vendors data: ${error instanceof Error ? error.message : 'Unknown error'}`);
      return [];
    }
  };

  // Create custom icon
  const createStreetVendorIcon = () => {
    return L.icon({
     iconUrl: laari,
     iconSize: [24, 24],
     iconAnchor: [12, 24],
     popupAnchor: [0, -24],
  });
};

  const createTiffinVendorIcon = () => {
    return L.icon({
     iconUrl: laariGreen,
     iconSize: [24, 24],
     iconAnchor: [12, 24],
     popupAnchor: [0, -24],
  });
};

  const initializeMap = () => {
    if (isMapInitialized) {
      return;
    }

    // Default center coordinates (Jaipur, Rajasthan)
    const defaultCoords: [number, number] = [26.9124, 75.7873];
    const initialCoords = userLocation
      ? [userLocation.latitude, userLocation.longitude]
      : defaultCoords;

    const initialZoom = userLocation ? 15 : 13;
    setCurrentZoom(initialZoom);

    console.log("Initializing map with coordinates:", initialCoords);
    
    // Check if map container exists
    const mapContainer = document.getElementById("map");
    if (!mapContainer) {
      console.error("Map container not found");
      return;
    }

    try {
      mapRef.current = L.map("map", { zoomControl: false }).setView(
        initialCoords as [number, number],
        initialZoom
      );

      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", // Changed to OSM to avoid potential issues
        {
          maxZoom: 19,
          attribution: '© OpenStreetMap contributors',
        }
      ).addTo(mapRef.current);

      // Add custom zoom control to bottom left
      L.control.zoom({ position: 'bottomleft' }).addTo(mapRef.current);

      // Handle zoom events
    mapRef.current.on("zoomend", () => {
    if (mapRef.current) {
    setCurrentZoom(mapRef.current.getZoom());
    }
    });

      // Add user location CSS
      const style = document.createElement("style");
      style.textContent = `
        .user-location-marker {
          background: transparent;
        }
        .pulse {
          width: 20px;
          height: 20px;
          background: rgba(0, 128, 255, 0.7);
          border-radius: 50%;
          box-shadow: 0 0 0 rgba(0, 128, 255, 0.4);
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(0, 128, 255, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(0, 128, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(0, 128, 255, 0);
          }
        }
        .vendor-cluster {
          background: #ff6b6b;
          border: 2px solid white;
          border-radius: 50%;
          color: white;
          font-weight: bold;
          text-align: center;
          line-height: 28px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        .filter-panel {
          background: white;
          border-radius: 8px;
          padding: 16px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-bottom: 16px;
        }
        .filter-section {
          margin-bottom: 16px;
        }
        .filter-section h3 {
          margin: 0 0 8px 0;
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }
        .filter-options {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .filter-chip {
          padding: 4px 12px;
          background: #f0f0f0;
          border: 1px solid #ddd;
          border-radius: 20px;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .filter-chip:hover {
          background: #e0e0e0;
        }
        .filter-chip.active {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }
        .filter-actions {
          display: flex;
          gap: 8px;
          margin-top: 12px;
        }
        .filter-button {
          padding: 6px 12px;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .filter-button:hover {
          background: #f5f5f5;
        }
        .filter-button.primary {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }
        .filter-button.primary:hover {
          background: #0056b3;
        }
        .active-filters-count {
          display: inline-block;
          background: #ff6b6b;
          color: white;
          border-radius: 10px;
          padding: 2px 6px;
          font-size: 10px;
          margin-left: 4px;
        }
      `;
      document.head.appendChild(style);

      setIsMapInitialized(true);
      console.log("Map initialized successfully");
    } catch (error) {
      console.error("Error initializing map:", error);
      setError("Failed to initialize map");
    }
  };

  const updateUserLocationMarker = () => {
    if (!mapRef.current || !userLocation) return;

    // Remove existing marker if it exists
    if (userLocationMarkerRef.current) {
      userLocationMarkerRef.current.remove();
    }

    // Create user location marker
    const userIcon = L.divIcon({
      className: "user-location-marker",
      html: '<div class="pulse"></div>',
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });

    userLocationMarkerRef.current = L.marker(
      [userLocation.latitude, userLocation.longitude],
      {
        icon: userIcon,
        zIndexOffset: 1000,
      }
    )
      .addTo(mapRef.current)
      .bindPopup("You are here");

    // Center map on user location with animation
    mapRef.current.flyTo(
      [userLocation.latitude, userLocation.longitude],
      15,
      {
        animate: true,
        duration: 1.5,
      }
    );
  };

  // Add this function to handle grouped vendors at the same location
  const createGroupedPopupContent = (vendorsAtLocation: Vendor[]) => {
    const count = vendorsAtLocation.length;
    
    return `
      <div class="grouped-popup" style="font-size: 12px; line-height: 1.4; min-width: 280px; max-width: 320px;">
        <!-- Header -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #eee;">
          <h3 style="margin: 0; font-size: 14px; font-weight: 600; color: #2c3e50;">${count} Vendors at this location</h3>
          <button onclick="event.stopPropagation(); this.closest('.leaflet-popup').style.display='none'" style="background: none; border: none; font-size: 16px; color: #999; cursor: pointer; padding: 2px;">×</button>
        </div>
        
        <!-- Vendor List -->
        <div style="max-height: 280px; overflow-y: auto;">
          ${vendorsAtLocation.map((vendor, index) => {
            const { status, color } = getOperatingStatus(vendor.operatingHours);
            return `
              <div class="vendor-item" style="
                display: flex; 
                align-items: center; 
                padding: 8px 6px; 
                margin-bottom: ${index < vendorsAtLocation.length - 1 ? '4px' : '0'}; 
                cursor: pointer; 
                border-radius: 6px;
                transition: background-color 0.2s;
              " 
              onclick="window.openVendorCard('${vendor._id}')"
              onmouseover="this.style.backgroundColor='#f8f9fa'"
              onmouseout="this.style.backgroundColor='transparent'">
                
                <!-- Vendor Avatar -->
                <div style="margin-right: 12px; flex-shrink: 0;">
                  ${vendor.profilePictures?.[0] ? `
                    <img src="${vendor.profilePictures[0]}" alt="${vendor.name}" style="
                      width: 32px; 
                      height: 32px; 
                      border-radius: 50%; 
                      object-fit: cover; 
                      border: 2px solid #ddd;
                    " />
                  ` : `
                    <div style="
                      width: 32px; 
                      height: 32px; 
                      border-radius: 50%; 
                      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
                      display: flex; 
                      align-items: center; 
                      justify-content: center; 
                      color: white; 
                      font-weight: bold; 
                      font-size: 14px;
                    ">
                      ${(vendor.name?.charAt(0) || '?').toUpperCase()}
                    </div>
                  `}
                </div>
                
                <!-- Vendor Info -->
                <div style="flex: 1; min-width: 0;">
                  <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 2px;">
                    <h4 style="margin: 0; font-size: 13px; font-weight: 600; color: #2c3e50; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 160px;">
                      ${vendor.name || 'Unnamed Vendor'}
                    </h4>
                    <span style="font-size: 16px; margin-left: 8px; flex-shrink: 0;">→</span>
                  </div>
                  
                  <div style="font-size: 11px; color: #666; margin-bottom: 3px;">
                    ${vendor.foodType || 'Food type not specified'}
                  </div>
                  
                  ${vendor.operatingHours ? `
                    <div style="display: flex; align-items: center;">
                      <span style="color: ${color}; margin-right: 4px; font-size: 8px;">●</span>
                      <span style="color: ${color}; font-size: 11px; font-weight: 500;">${status}</span>
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
          }).join('')}
        </div>
        
        <!-- Footer -->
        <div style="text-align: center; margin-top: 12px; padding-top: 8px; border-top: 1px solid #eee;">
          <span style="color: #666; font-size: 11px; font-style: italic;">Click any vendor to view full details</span>
        </div>
      </div>
    `;
  };

  // Helper function to get food type display info
  const getFoodTypeDisplay = (foodType?: string) => {
  switch (foodType) {
    case 'veg':
      return { color: '#28a745', text: 'Veg' };
    case 'nonveg':
      return { color: '#dc3545', text: 'Non-Veg' };
    case 'non-veg':
      return { color: '#dc3545', text: 'Non-Veg' };
    default:
      return { color: '#6c757d', text: foodType || 'Food type not specified' };
  }
};

  // Updated updateMapMarkers function to group vendors by location
  const updateMapMarkers = (vendorsToDisplay: Vendor[]) => {
    if (!mapRef.current || !isMapInitialized) {
      console.log("Map not initialized, skipping marker update");
      return;
    }

    console.log("Updating map markers for vendors:", vendorsToDisplay.length);

    // Clear existing vendor markers
    Object.values(markersRef.current).forEach((marker) => marker.remove());
    markersRef.current = {};

    // Group vendors by location (within ~50 meters)
    const locationGroups: { [key: string]: Vendor[] } = {};
    const processedVendors = new Set<string>();

    vendorsToDisplay.forEach((vendor) => {
      if (processedVendors.has(vendor._id)) return;

      // Get coordinates for this vendor
      let coords = getVendorCoordinates(vendor);
      
      if (!coords) {
        console.log(`Could not determine coordinates for ${vendor.name}`);
        return;
      }

      // Group ONLY vendors having exactly the same coordinates
    const locationKey = `${coords.latitude.toFixed(6)}_${coords.longitude.toFixed(6)}`;

      if (!locationGroups[locationKey]) {
        locationGroups[locationKey] = [];
      }

locationGroups[locationKey].push(vendor);
processedVendors.add(vendor._id);
    });

    // Create markers for each location group
    Object.entries(locationGroups).forEach(([locationKey, vendorsAtLocation]) => {
      if (vendorsAtLocation.length === 0) return;

      // Use the first vendor's coordinates as the group location
      const firstVendor = vendorsAtLocation[0];
      let coords = getVendorCoordinates(firstVendor);
      
      if (!coords) return;

      try {
        let popupContent: string;
        let customIcon: L.Icon | L.DivIcon;



        
  console.log(
    vendorsAtLocation.length,
    vendorsAtLocation.map(v => ({
        name: v.name,
        type: v.vendorType
    }))
);




        if (vendorsAtLocation.length === 1) {
          // Single vendor - use existing popup design
          const vendor = vendorsAtLocation[0];
          console.log(
          vendor.name,
          (vendor as any).vendorType
           );
          const { status, color } = getOperatingStatus(vendor.operatingHours);
          
          popupContent = `
            <div class="custom-popup" style="font-size: 12px; line-height: 1.4; min-width: 200px; cursor: pointer;" onclick="window.openVendorCard('${vendor._id}')">
              <div style="display: flex; align-items: flex-start; margin-bottom: 8px;">
                ${vendor.profilePictures?.[0] ? `
                  <img src="${vendor.profilePictures[0]}" alt="${vendor.name}" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; margin-right: 12px; border: 2px solid #ddd;" />
                ` : `
                  <div style="width: 40px; height: 40px; border-radius: 50%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); margin-right: 12px; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 16px;">
                    ${(vendor.name?.charAt(0) || '?').toUpperCase()}
                  </div>
                `}
                <div style="flex: 1;">
                  <h3 style="margin: 0 0 4px 0; font-size: 14px; font-weight: 600; color: #2c3e50;">${vendor.name}</h3>
                  ${vendor.foodType ? `<div style="color: #666; font-size: 11px; margin-bottom: 4px;">${vendor.foodType}</div>` : ''}
                  ${vendor.operatingHours ? `
                    <div style="display: flex; align-items: center;">
                      <span style="color: ${color}; margin-right: 4px; font-size: 10px;">●</span>
                      <span style="color: ${color}; font-size: 11px;">${status}</span>
                    </div>
                  ` : ''}
                </div>
              </div>
              <div style="text-align: center; color: #007bff; font-size: 11px; font-weight: 500; margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee;">
                Click to view full details →
              </div>
            </div>
          `;
          
          customIcon =
          vendor.vendorType === "tiffin_maker"
          ? createTiffinVendorIcon()
          : createStreetVendorIcon();
        } else {
        
          // Multiple vendors - use grouped popup
          popupContent = createGroupedPopupContent(vendorsAtLocation);
          


          const allTiffin = vendorsAtLocation.every(
        vendor => vendor.vendorType === "tiffin_maker"
        );

        const allStreet = vendorsAtLocation.every(
        vendor => vendor.vendorType === "street_vendor"
        );

         const clusterColor =
        allTiffin
        ? "#2E7D32"
        : allStreet
        ? "#C80B41"
        : "#F39C12";   // mixed cluster



          // Create clustered icon with count
          customIcon = L.divIcon({
            className: 'vendor-cluster',
            html: `
              <div style="
                background: ${clusterColor};
                color: white;
                border-radius: 50%;
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 12px;
                border: 3px solid white;
                box-shadow: 0 2px 6px rgba(0,0,0,0.3);
              ">
                ${vendorsAtLocation.length}
              </div>
            `,
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -32],
          });
        }

        const marker = L.marker([coords.latitude, coords.longitude], {
          icon: customIcon,
        })
          .addTo(mapRef.current!)
          .bindPopup(popupContent, {
            maxWidth: vendorsAtLocation.length > 1 ? 320 : 250,
            className: vendorsAtLocation.length > 1 ? 'grouped-popup-container' : 'custom-popup-container'
          });

        // Add click tracking for each vendor in the group
        vendorsAtLocation.forEach(vendor => {
          marker.on('click', async () => {
            try {
              await trackVendorClick(vendor._id);
              console.log(`Tracked click for vendor: ${vendor.name || vendor.businessName || vendor.vendorName}`);
            } catch (error) {
              console.error('Error tracking vendor click:', error);
            }
          });
        });

        // Store marker with a combined key for grouped locations
        const markerKey = vendorsAtLocation.length === 1 
          ? vendorsAtLocation[0]._id 
          : `group_${locationKey}`;
        markersRef.current[markerKey] = marker;
        
        console.log(`Successfully added marker for ${vendorsAtLocation.length} vendor(s) at location`);
      } catch (markerError) {
        console.error(`Error creating marker for location group:`, markerError);
      }
    });

    console.log(`Added ${Object.keys(markersRef.current).length} markers to map`);

    // Fit map bounds if no user location
    if (Object.keys(markersRef.current).length > 0 && !userLocation) {
      try {
        const group = L.featureGroup(Object.values(markersRef.current));
        mapRef.current.fitBounds(group.getBounds().pad(0.1));
        console.log("Fitted map bounds to include all markers");
      } catch (boundsError) {
        console.error("Error fitting bounds:", boundsError);
      }
    }
  };

  // Setup initial conditions
  useEffect(() => {
    console.log("MapDisplay component mounted, getting user location...");
    getUserLocation();

    // Cleanup function
    return () => {
      console.log("MapDisplay component unmounting, cleaning up...");
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
      Object.values(markersRef.current).forEach((marker) => marker.remove());
      markersRef.current = {};
      if (userLocationMarkerRef.current) {
        userLocationMarkerRef.current.remove();
        userLocationMarkerRef.current = null;
      }
      setIsMapInitialized(false);
    };
  }, []);

  // Initialize map once we know about user location (or timeout occurred)
  useEffect(() => {
    if (!isLocationLoading && !isMapInitialized) {
      console.log("Location loading complete, initializing map...");
      initializeMap();
    }
  }, [isLocationLoading, isMapInitialized]);

  // Add user location marker after map is initialized and location is available
  useEffect(() => {
    if (isMapInitialized && userLocation) {
      console.log("Map initialized and user location available, updating user marker...");
      updateUserLocationMarker();
    }
  }, [isMapInitialized, userLocation]);

  // Fetch vendors after map is initialized
  useEffect(() => {
    if (isMapInitialized) {
      console.log("Map initialized, fetching vendors...");
      const loadVendors = async () => {
        const vendorData = await fetchVendors();
        if (vendorData && vendorData.length > 0) {
          console.log("Fetched vendor data:", vendorData);
          updateMapMarkers(vendorData);
        } else {
          console.log("No vendor data received");
        }
      };
      loadVendors();

      // Setup refresh interval (reduced frequency to avoid overwhelming the server)
      const intervalId = window.setInterval(() => {
        console.log("Refreshing vendor data...");
        loadVendors();
      }, 300000); // Check every 5 minutes instead of 1 minute

      return () => {
        window.clearInterval(intervalId);
      };
    }
  }, [isMapInitialized]);

  // Update markers whenever vendors, filtered vendors, or zoom level changes
  useEffect(() => {
    if (isMapInitialized && vendors.length > 0) {
      console.log("Vendors or zoom changed, updating markers...");
      // Use filtered vendors if available, otherwise use all vendors
     const hasActiveFilters =
     activeFilters.foodTypes.length > 0 ||
     activeFilters.categories.length > 0 ||
     showOnlyOpen;

    const vendorsToShow = hasActiveFilters
    ? filteredVendors
    : vendors;
      updateMapMarkers(vendorsToShow);
    }
     }, [
     vendors,
     filteredVendors,
     currentZoom,
     isMapInitialized,
     activeFilters,
     showOnlyOpen
     ]);

  // Apply filters when vendors are loaded
  useEffect(() => {
    if (vendors.length > 0) {
      if (activeFilters.foodTypes.length > 0 || activeFilters.categories.length > 0 || showOnlyOpen) {
        const filtered = applyFilters(vendors);
        setFilteredVendors(filtered);
      } else {
        // No filters active, show all vendors
        setFilteredVendors([]);
      }
    }
  }, [vendors, activeFilters, showOnlyOpen]);

  // Add location refresh button
  const refreshUserLocation = () => {
    console.log("Refreshing user location...");
    getUserLocation();
  };

  // Add open/close functions
  const openVendorCard = (vendor: Vendor) => {
    if (selectedVendor && selectedVendor._id !== vendor._id) {
      setIsVendorCardVisible(false);
      setTimeout(() => {
        setSelectedVendor(vendor);
        setIsVendorCardVisible(true);
      }, 800); // match the sidebar transition duration
    } else {
      setSelectedVendor(vendor);
      setIsVendorCardVisible(true);
    }
  };
  const closeVendorCard = () => {
    setSelectedVendor(null);
    setIsVendorCardVisible(false);
  };

  // Add global handler
  (window as any).openVendorCard = (vendorId: string) => {
    // First try to find vendor in filtered vendors, then in all vendors
const hasActiveFilters =
  activeFilters.foodTypes.length > 0 ||
  activeFilters.categories.length > 0 ||
  showOnlyOpen;

const vendor = (hasActiveFilters ? filteredVendors : vendors)
.find(v => v._id === vendorId);    if (vendor) {
      openVendorCard(vendor);
    }
  };

  // Enhanced search bar logic with area functionality
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSearchResults([]);
      setShowSuggestions(false);
      // Don't clear filtered vendors when search is cleared - keep filters active
      return;
    }

    const lowerSearch = searchTerm.toLowerCase();
    const results: any[] = [];
    const areaMatches: Array<{
      type: 'area';
      name: string;
      displayName: string;
      coordinates: { lat: number; lng: number; zoom: number };
    }> = [];

    // Check for area matches first
    Object.keys(AREA_BOUNDARIES).forEach(area => {
      if (area.toLowerCase().includes(lowerSearch)) {
        areaMatches.push({
          type: 'area',
          name: area,
          displayName: `${area.charAt(0).toUpperCase() + area.slice(1)} Area`,
          coordinates: AREA_BOUNDARIES[area]
        });
      }
    });

    // Use filtered vendors if available, otherwise use all vendors
     const hasActiveFilters =
     activeFilters.foodTypes.length > 0 ||
     activeFilters.categories.length > 0 ||
     showOnlyOpen;

    const vendorsToSearch = hasActiveFilters
    ? filteredVendors
    : vendors;
    // Filter vendors by name and menu items
    const vendorResults = vendorsToSearch.filter(vendor => {
      // Match vendor name
      if ((vendor.name || '').toLowerCase().includes(lowerSearch)) {
        return true;
      }
      // Match menu items (bestDishes)
      if (Array.isArray(vendor.bestDishes)) {
        return vendor.bestDishes.some(dish =>
          (dish.name || '').toLowerCase().includes(lowerSearch)
        );
      }
      return false;
    });

    // Filter vendors by area if area is specified
    if (lowerSearch.length > 2) {
      const areaVendors = vendorsToSearch.filter(vendor => {
        const vendorArea = (vendor.area || vendor.location?.area || '').toLowerCase();
        return vendorArea.includes(lowerSearch);
      });
      
      // Add area-specific vendor results
      if (areaVendors.length > 0) {
        results.push({
          type: 'area-vendors',
          area: lowerSearch,
          vendors: areaVendors,
          displayName: `${areaVendors.length} vendors in ${lowerSearch}`
        });
      }
    }

    // Combine all results: areas first, then area-vendors, then individual vendors
    const finalResults = [...areaMatches, ...results, ...vendorResults];
    
    setSearchResults(finalResults);
    setShowSuggestions(true);
  }, [searchTerm, vendors, filteredVendors]);

  // Enhanced search selection handler
  const handleSearchSelect = (result: any) => {
    if (result.type === 'area') {
      // Handle area selection - center map on area
      setSearchTerm(result.displayName);
      setShowSuggestions(false);
      
      if (mapRef.current) {
        mapRef.current.flyTo(
          [result.coordinates.lat, result.coordinates.lng], 
          result.coordinates.zoom,
          {
            animate: true,
            duration: 1.5
          }
        );
      }
      
      // Optionally filter vendors by area
      filterVendorsByArea(result.name);
      
    } else if (result.type === 'area-vendors') {
      // Handle area-vendors selection - show all vendors in that area
      setSearchTerm(`Vendors in ${result.area}`);
      setShowSuggestions(false);
      
      // Center map on area and show all vendors
      const firstVendor = result.vendors[0];
      if (firstVendor && mapRef.current) {
        const coords = getVendorCoordinates(firstVendor);
        if (coords) {
          mapRef.current.flyTo([coords.latitude, coords.longitude], 14, {
            animate: true,
            duration: 1.5
          });
        }
      }
      
      // Highlight all vendors in the area
      highlightAreaVendors(result.vendors);
      
    } else {
      // Handle individual vendor selection (original logic)
      setSearchTerm(result.name || '');
      setShowSuggestions(false);
      
      let coords = getVendorCoordinates(result);
      if (coords && mapRef.current) {
        mapRef.current.flyTo([coords.latitude, coords.longitude], 17, {
          animate: true,
          duration: 1.5
        });
        
        // Find the marker - it might be in a group
        const marker = markersRef.current[result._id];
        if (marker) {
          marker.openPopup();
        }
        openVendorCard(result);
      }
    }
  };

  // Replace all coordinate extraction logic for vendors in MapDisplay with the following helper:
  const getVendorCoordinates = (vendor: Vendor): { latitude: number; longitude: number } | null => {
    // 1. Try latitude/longitude fields (from backend - WhatsApp or mapsLink)
    if (typeof vendor.latitude === 'number' && typeof vendor.longitude === 'number') {
      if (isValidAhmedabadCoordinate(vendor.latitude, vendor.longitude)) {
        console.log(`Vendor ${vendor.name}: Using ${(vendor as any).locationSource || 'unknown'} location: ${vendor.latitude}, ${vendor.longitude}`);
        return { latitude: vendor.latitude, longitude: vendor.longitude };
      } else {
        console.warn(`Vendor ${vendor.name} has invalid coordinates: ${vendor.latitude}, ${vendor.longitude}`);
      }
    }
    
    // 2. Try mapsLink extraction (fallback)
    if (vendor.mapsLink) {
      const coords = extractCoordinates(vendor.mapsLink);
      if (coords) {
        console.log(`Vendor ${vendor.name}: Using mapsLink fallback: ${coords.latitude}, ${coords.longitude}`);
        return coords;
      }
    }
    
    // 3. Try location.coordinates (legacy WhatsApp pin format)
    if ((vendor as any).location && Array.isArray((vendor as any).location.coordinates) && (vendor as any).location.coordinates.length === 2) {
      const lat = (vendor as any).location.coordinates[1];
      const lng = (vendor as any).location.coordinates[0];
      
      if (isValidAhmedabadCoordinate(lat, lng)) {
        console.log(`Vendor ${vendor.name}: Using legacy location.coordinates: ${lat}, ${lng}`);
        return { latitude: lat, longitude: lng };
      } else {
        console.warn(`Vendor ${vendor.name} has invalid location coordinates: ${lat}, ${lng}`);
      }
    }
    
    console.warn(`No valid coordinates found for vendor: ${vendor.name}`);
    return null;
  };

  // Helper function to filter vendors by area
  const filterVendorsByArea = (area: string) => {
    // Apply area filter on top of existing filters
    const currentFiltered = applyFilters(vendors);
    const areaFiltered = currentFiltered.filter(vendor => {
      const vendorArea = (vendor.area || vendor.location?.area || '').toLowerCase();
      return vendorArea.includes(area.toLowerCase());
    });
    
    setFilteredVendors(areaFiltered);
  };

  // Helper function to highlight area vendors
  const highlightAreaVendors = (areaVendors: Vendor[]) => {
    // Close all existing popups
    Object.values(markersRef.current).forEach(marker => {
      if (marker) marker.closePopup();
    });
    
    // Open popups for area vendors
    areaVendors.forEach(vendor => {
      // Check if vendor has an individual marker
      const marker = markersRef.current[vendor._id];
      if (marker) {
        marker.openPopup();
      } else {
        // Vendor might be in a group marker, try to find it
        Object.entries(markersRef.current).forEach(([key, marker]) => {
          if (key.startsWith('group_')) {
            // This is a group marker, we can't easily highlight individual vendors
            // Just open the group popup
            marker.openPopup();
          }
        });
      }
    });
  };

  // Handle Enter key press for area search
  const handleSearchKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      const lowerSearch = searchTerm.toLowerCase().trim();
      
      // Check if it's an area name
      const matchedArea = Object.keys(AREA_BOUNDARIES).find(area => 
        area.toLowerCase() === lowerSearch
      );
      
      if (matchedArea) {
        // Center map on the area
        const coordinates = AREA_BOUNDARIES[matchedArea];
        if (mapRef.current) {
          mapRef.current.flyTo(
            [coordinates.lat, coordinates.lng], 
            coordinates.zoom,
            {
              animate: true,
              duration: 1.5
            }
          );
        }
        
        // Filter vendors by area
        filterVendorsByArea(matchedArea);
        setShowSuggestions(false);
      } else {
        // Try geocoding for unknown areas (optional)
        geocodeAndCenterMap(searchTerm);
      }
    }
  };

  // Optional: Geocoding function for unknown areas
  const geocodeAndCenterMap = async (searchTerm: string) => {
    try {
      // Using a geocoding service (example with OpenStreetMap Nominatim)
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchTerm)}&limit=1`
      );
      const data = await response.json();
      
      if (data && data.length > 0) {
        const result = data[0];
        if (mapRef.current) {
          mapRef.current.flyTo([parseFloat(result.lat), parseFloat(result.lon)], 13, {
            animate: true,
            duration: 1.5
          });
        }
      }
    } catch (error) {
      console.error('Geocoding error:', error);
    }
  };

  // Fetch reviews when vendor card opens
  useEffect(() => {
    if (isVendorCardVisible && selectedVendor) {
      api.getReviews(selectedVendor._id).then(res => {
        if (res.success && res.data) setReviews(res.data);
        else setReviews([]);
      });
    }
  }, [isVendorCardVisible, selectedVendor]);

  const handleReviewInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setReviewForm({ ...reviewForm, [e.target.name]: e.target.value });
  };

  const handleStarClick = (star: number) => {
    setReviewForm({ ...reviewForm, rating: star });
  };

  const handleReviewSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setReviewError(null);
    if (!selectedVendor) return;
    if (!reviewForm.name || !reviewForm.email || !reviewForm.rating) {
      setReviewError('Name, email, and rating are required.');
      setSubmitting(false);
      return;
    }
    const reviewData = {
      vendorId: selectedVendor._id,
      name: reviewForm.name,
      email: reviewForm.email,
      rating: reviewForm.rating,
      comment: reviewForm.comment,
    };
    const res = await api.addReview(reviewData);
    if (res.success && res.data) {
      setReviews([res.data, ...reviews]);
      setReviewForm({ name: '', email: '', rating: 0, comment: '' });
      setShowAllReviews(false);
      setSubmitting(false);
    } else {
      setReviewError(res.error || 'Failed to submit review.');
    }
  };

  // Touch/swipe functionality for carousel
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && selectedVendor?.carouselImages) {
      const newIndex = (currentImageIndex + 1) % selectedVendor.carouselImages.length;
      setCurrentImageIndex(newIndex);
    } else if (isRightSwipe && selectedVendor?.carouselImages) {
      const newIndex = currentImageIndex === 0 
        ? selectedVendor.carouselImages.length - 1 
        : currentImageIndex - 1;
      setCurrentImageIndex(newIndex);
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  {/*const handleGoogleSignIn = () => {
    // @ts-ignore
    if (window.google && window.google.accounts && window.google.accounts.id) {
      // @ts-ignore
      window.google.accounts.id.initialize({
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
        callback: async (response: any) => {
          try {
            const res = await api.googleLogin(response.credential);
            if (res.success && res.data) {
              localStorage.setItem('lk_auth_token', res.data.accessToken);
              localStorage.setItem('lk_auth_name', res.data.name);
              localStorage.setItem('lk_auth_email', res.data.email);
              setAuth({ name: res.data.name, email: res.data.email });
            }
          } catch (e) {
            console.error('Google login failed', e);
          }
        }
      });
      // @ts-ignore
      window.google.accounts.id.prompt();
    } else {
      console.error('Google Identity Services not loaded');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('lk_auth_token');
    localStorage.removeItem('lk_auth_name');
    localStorage.removeItem('lk_auth_email');
    setAuth(null);
  };*/}

  return (
    <div style={{ height: "100vh", width: "100vw", position: "relative" }}>
      {/* Top bar: Logo and Search Bar with Buttons */}
      <div
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          right: '20px',
          zIndex: 1200,
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          pointerEvents: 'none', // allow map interaction except for children
        }}
      >
        {/* Logo */}
        <div
          style={{
            cursor: 'pointer',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            height: '60px',
            flexShrink: 0,
          }}
          onClick={() => navigate('/')}
        >
          <img src={logo} alt="Laari Logo" style={{ height: '60px', width: 'auto' }} />
        </div>
        
        {/* Search Bar */}
        <div
          className="mobile-search-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            pointerEvents: 'auto',
            position: 'relative',
          }}
        >
          <input
            type="text"
            placeholder="Search for a vendor or area..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onFocus={() => setShowSuggestions(searchResults.length > 0)}
            onKeyPress={handleSearchKeyPress}
            style={{
              width: '100%',
              maxWidth: '600px',
              padding: '12px 20px',
              borderRadius: '25px',
              border: '1px solid #ddd',
              fontSize: '14px',
              outline: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: 'white',
            }}
                    />
          {showSuggestions && searchResults.length > 0 && (
            <div style={{
              position: 'absolute',
              top: '48px',
              left: 0,
              width: '100%',
              background: 'white',
              border: '1px solid #eee',
              borderRadius: '0 0 12px 12px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              maxHeight: '220px',
              overflowY: 'auto',
              zIndex: 1300,
            }}>
              {searchResults.map((result, index) => {
                if (result.type === 'area') {
                  return (
                    <div
                      key={`area-${index}`}
                      onClick={() => handleSearchSelect(result)}
                      style={{
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f3f3f3',
                        fontWeight: 500,
                        color: '#2c3e50',
                        background: '#e8f4fd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                      onMouseDown={e => e.preventDefault()}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px', fontSize: '16px' }}>📍</span>
                        <span>{result.displayName}</span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Area</span>
                    </div>
                  );
                } else if (result.type === 'area-vendors') {
                  return (
                    <div
                      key={`area-vendors-${index}`}
                      onClick={() => handleSearchSelect(result)}
                      style={{
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f3f3f3',
                        fontWeight: 500,
                        color: '#2c3e50',
                        background: '#fff3cd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                      onMouseDown={e => e.preventDefault()}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px', fontSize: '16px' }}>🏪</span>
                        <span>{result.displayName}</span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Area Vendors</span>
                    </div>
                  );
                } else {
                  // Individual vendor
                  return (
                    <div
                      key={result._id}
                      onClick={() => handleSearchSelect(result)}
                      style={{
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f3f3f3',
                        fontWeight: 500,
                        color: '#2c3e50',
                        background: searchTerm === result.name ? '#f5f8ff' : 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                      onMouseDown={e => e.preventDefault()}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px', fontSize: '16px' }}>🍽️</span>
                        <span>{result.name}</span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Vendor</span>
                    </div>
                  );
                }
              })}
            </div>
          )}
        </div>
        
                {/* Filter Buttons - Right next to search bar */}
        <div
          className="desktop-filter-buttons"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            pointerEvents: 'auto',
            position: 'relative',
          }}
        >
        {/* Filter Toggle Button */}
        <button
          onClick={() => setShowFilters(!showFilters)}
          style={{
            padding: '6px 12px',
            backgroundColor: 'white',
            border: '1px solid #C80B41',
            borderRadius: '18px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            color: '#C80B41',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'all 0.2s',
            pointerEvents: 'auto',
            minWidth: '80px',
            justifyContent: 'center',
          }}
          onMouseEnter={(e) => {
            (e.target as HTMLButtonElement).style.backgroundColor = '#fff5f7';
          }}
          onMouseLeave={(e) => {
            (e.target as HTMLButtonElement).style.backgroundColor = 'white';
          }}
        >
          <span style={{ fontSize: '14px' }}>🔍</span>
          Filters
          {(activeFilters.foodTypes.length > 0 || activeFilters.categories.length > 0) && (
            <span className="active-filters-count">
              {activeFilters.foodTypes.length + activeFilters.categories.length}
            </span>
          )}
        </button>

        {/* What's Open Now Button */}
        <button
          onClick={() => {
            const newShowOnlyOpen = !showOnlyOpen;
            setShowOnlyOpen(newShowOnlyOpen);
            
            if (newShowOnlyOpen) {
              // Apply open filter immediately
              const filtered = applyFilters(vendors);
              setFilteredVendors(filtered);
            } else {
              // Clear open filter - show all vendors or apply other active filters
              if (activeFilters.foodTypes.length === 0 && activeFilters.categories.length === 0) {
                setFilteredVendors([]); // This will show all vendors in the useEffect
              } else {
                // Reapply other active filters
                const filtered = applyFilters(vendors);
                setFilteredVendors(filtered);
              }
            }
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: showOnlyOpen ? '#C80B41' : 'white',
            border: '1px solid #C80B41',
            borderRadius: '18px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: '500',
            color: showOnlyOpen ? 'white' : '#C80B41',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'all 0.2s',
            pointerEvents: 'auto',
            minWidth: '100px',
            justifyContent: 'center',
          }}
          onMouseEnter={(e) => {
            if (!showOnlyOpen) {
              (e.target as HTMLButtonElement).style.backgroundColor = '#fff5f7';
            }
          }}
          onMouseLeave={(e) => {
            if (!showOnlyOpen) {
              (e.target as HTMLButtonElement).style.backgroundColor = 'white';
            }
          }}
        >
          <span style={{ fontSize: '14px' }}>🕐</span>
          {showOnlyOpen ? 'Show All' : "What's Open Now"}
        </button>

        {/* Filter Panel Content */}
                {showFilters && (
          <div className="filter-panel" style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            marginTop: '12px',
            pointerEvents: 'auto',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            minWidth: '300px',
            zIndex: 1201,
            maxWidth: '400px',
          }}>
            {/* Vendor Count */}
            <div style={{ 
              marginBottom: '16px', 
              padding: '8px 12px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '6px',
              fontSize: '12px',
              color: '#666',
              textAlign: 'center'
            }}>
        Showing {hasActiveFilters ? filteredVendors.length : vendors.length} of {vendors.length} vendors
              {showOnlyOpen && (
                <div style={{ 
                  fontSize: '11px', 
                  color: '#C80B41', 
                  fontWeight: '500',
                  marginTop: '2px'
                }}>
                  (Open now only)
                </div>
              )}
            </div>

            {/* Food Type Filters */}
            <div className="filter-section">
              <h3>Food Type</h3>
              <div className="filter-options">
                {FOOD_TYPES.map(type => (
                  <button
                    key={type}
                    className={`filter-chip ${activeFilters.foodTypes.includes(type) ? 'active' : ''}`}
                    onClick={() => handleFilterChange('foodTypes', type)}
                  >
                    {type === 'veg' ? '🥬' : type === 'non-veg' ? '🍗' : type === 'swaminarayan' ? '🕉️' : '☸️'} {type.charAt(0).toUpperCase() + type.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {/* Category Filters */}
            <div className="filter-section">
              <h3>Food Categories</h3>
              <div className="filter-options">
                {FOOD_CATEGORIES.map(category => (
                  <button
                    key={category}
                    className={`filter-chip ${activeFilters.categories.includes(category) ? 'active' : ''}`}
                    onClick={() => handleFilterChange('categories', category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Filter Actions */}
            <div className="filter-actions">
              <button
                className="filter-button"
                onClick={clearAllFilters}
              >
                Clear All
              </button>
              <button
                className="filter-button primary"
                onClick={() => setShowFilters(false)}
              >
                Apply
              </button>
            </div>
          </div>
        )}
        </div>
      </div>
      
      {/* Error message covers search bar and can be dismissed */}
      {error && showError && (
        <div
          className="error-message"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            backgroundColor: "#ff4d4d",
            color: "white",
            padding: "14px 60px 14px 24px",
            borderRadius: 0,
            zIndex: 1201,
            maxWidth: "100vw",
            textAlign: "left",
            fontSize: "20px",
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
          }}
        >
          <span style={{ flex: 1 }}>{error}</span>
          <button
            onClick={() => setShowError(false)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '28px',
              fontWeight: 700,
              cursor: 'pointer',
              marginLeft: '16px',
              lineHeight: 1,
              padding: 0,
              opacity: 0.85,
              transition: 'opacity 0.2s',
            }}
            aria-label="Close error message"
            title="Close"
            onMouseEnter={e => (e.currentTarget.style.opacity = '1')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '0.85')}
          >
            ×
          </button>
        </div>
      )}
      {/* Map Content */}
      <div id="map" style={{ width: "100%", height: "100%", flexGrow: 1 }}></div>
      
      {/* Mobile/Tablet Filter Buttons */}
      <div className="mobile-filter-buttons">
        {/* Filter Button */}
        <button
          className={`mobile-filter-button ${showFilters ? 'selected' : ''}`}
          onClick={() => setShowFilters(!showFilters)}
          title="Filters"
          style={{ position: 'relative' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46" />
          </svg>
          {(activeFilters.foodTypes.length > 0 || activeFilters.categories.length > 0) && (
            <div
              style={{
                position: 'absolute',
                top: '-4px',
                right: '-4px',
                backgroundColor: '#ff4444',
                color: 'white',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid white',
              }}
            >
              {activeFilters.foodTypes.length + activeFilters.categories.length}
            </div>
          )}
        </button>
        
        {/* What's Open Now Button */}
        <button
          className={`mobile-filter-button ${showOnlyOpen ? 'selected' : ''}`}
          onClick={() => {
            const newShowOnlyOpen = !showOnlyOpen;
            setShowOnlyOpen(newShowOnlyOpen);
            
            if (newShowOnlyOpen) {
              // Apply open filter immediately
              const filtered = applyFilters(vendors);
              setFilteredVendors(filtered);
            } else {
              // Clear open filter - show all vendors or apply other active filters
              if (activeFilters.foodTypes.length === 0 && activeFilters.categories.length === 0) {
                setFilteredVendors([]); // This will show all vendors in the useEffect
              } else {
                // Reapply other active filters
                const filtered = applyFilters(vendors);
                setFilteredVendors(filtered);
              }
            }
          }}
          title="What's Open Now"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12,6 12,12 16,14" />
          </svg>
        </button>
      </div>
      
      {/* Mobile Filter Panel - Appears at bottom of page (only on mobile/tablet) */}
      {showFilters && isMobileOrTablet && (
        <>
          {/* Mobile backdrop overlay */}
          <div 
            className="mobile-filter-backdrop"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1299,
            }}
            onClick={() => setShowFilters(false)}
          />
          <div className="filter-panel mobile-filter-panel" style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'white',
            borderRadius: '20px 20px 0 0',
            padding: '24px 20px 32px 20px',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
            zIndex: 1300,
            maxHeight: '70vh',
            overflowY: 'auto',
          }}>
            {/* Vendor Count */}
            <div style={{ 
              marginBottom: '16px', 
              padding: '8px 12px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '6px',
              fontSize: '12px',
              color: '#666',
              textAlign: 'center'
            }}>
       Showing {hasActiveFilters ? filteredVendors.length : vendors.length} of {vendors.length} vendors
              {showOnlyOpen && (
                <div style={{ 
                  fontSize: '11px', 
                  color: '#C80B41', 
                  fontWeight: '500',
                  marginTop: '2px'
                }}>
                  (Open now only)
                </div>
              )}
            </div>

            {/* Food Type Filters */}
            <div className="filter-section">
              <h3>Food Type</h3>
              <div className="filter-options">
                {FOOD_TYPES.map(type => (
                  <button
                    key={type}
                    className={`filter-chip ${activeFilters.foodTypes.includes(type) ? 'active' : ''}`}
                    onClick={() => handleFilterChange('foodTypes', type)}
                  >
                    {type === 'veg' ? '🥬' : type === 'non-veg' ? '🍗' : type === 'swaminarayan' ? '🕉️' : '☸️'} {type.charAt(0).toUpperCase() + type.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {/* Category Filters */}
            <div className="filter-section">
              <h3>Food Categories</h3>
              <div className="filter-options">
                {FOOD_CATEGORIES.map(category => (
                  <button
                    key={category}
                    className={`filter-chip ${activeFilters.categories.includes(category) ? 'active' : ''}`}
                    onClick={() => handleFilterChange('categories', category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Filter Actions */}
            <div className="filter-actions">
              <button
                className="filter-button"
                onClick={clearAllFilters}
              >
                Clear All
              </button>
              <button
                className="filter-button primary"
                onClick={() => setShowFilters(false)}
              >
                Apply
              </button>
            </div>
          </div>
        </>
      )}
      
      {/* Top right controls */}
      <div style={{
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 1201,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 12,
      }}>
        <button
          className="refresh-btn-desktop"
          onClick={refreshUserLocation}
          style={{
            padding: '8px',
            borderRadius: '50%',
            backgroundColor: 'white',
            border: '2px solid #007bff',
            cursor: 'pointer',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 2px 5px rgba(0,0,0,0.12)',
          }}
          title="Refresh Location"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#007bff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
        </button>
        {/* Zoom controls will be rendered by Leaflet, but you can add custom ones here if needed */}
      </div>
      {isLocationLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "5px",
            zIndex: 1000,
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <div>Loading your location...</div>
          <div
            style={{
              width: "30px",
              height: "30px",
              border: "5px solid #f3f3f3",
              borderTop: "5px solid #3498db",
              borderRadius: "50%",
              margin: "10px auto",
              animation: "spin 2s linear infinite",
            }}
          ></div>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}
      {isVendorCardVisible && selectedVendor && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '320px',
            height: '100vh',
            backgroundColor: 'white',
            zIndex: 2000,
            boxShadow: '2px 0 15px rgba(0,0,0,0.15)',
            overflow: 'auto',
            transform: isVendorCardVisible ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.8s cubic-bezier(0.4, 0.0, 0.2, 1)'
          }}
        >
          <button
            onClick={closeVendorCard}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'rgba(0,0,0,0.1)',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#666',
              zIndex: 2001,
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => (e.target as HTMLButtonElement).style.backgroundColor = 'rgba(0,0,0,0.2)'}
            onMouseLeave={(e) => (e.target as HTMLButtonElement).style.backgroundColor = 'rgba(0,0,0,0.1)'}
          >
            ×
          </button>
          
          <div style={{ padding: '20px 16px' }}>
            {/* Profile Picture and Name */}
            <div style={{ textAlign: 'center', marginBottom: '20px', position: 'relative' }}>
              <div 
                onClick={() => {
                  setUploadType('profile');
                  setShowImageUploadModal(true);
                }}
                style={{ 
                  cursor: 'pointer',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                {selectedVendor.profilePictures?.[0] ? (
                  <img
                    src={selectedVendor.profilePictures[0]}
                    alt={selectedVendor.name || 'Vendor'}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '3px solid #eee',
                      marginBottom: '8px',
                    }}
                  />
                ) : (
                  <div style={{
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '28px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                  }}>
                    {(selectedVendor.name?.charAt(0) || '?').toUpperCase()}
                  </div>
                )}
                {/* Upload indicator */}
                <div style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: '#007bff',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  border: '2px solid white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                }}>
                  +
                </div>
              </div>
              <h2 style={{ 
                margin: '8px 0 4px 0', 
                color: '#2c3e50', 
                fontSize: '18px',
                fontWeight: '600',
                lineHeight: '1.2'
              }}>
                {selectedVendor.name || 'Not available'}
              </h2>

              

              {/* Food Type Tag */}
              {selectedVendor.foodType && (
                <div style={{
                  display: 'inline-block',
                  backgroundColor: getFoodTypeDisplay(selectedVendor.foodType).color,
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: '600',
                  marginBottom: '12px',
                  textAlign: 'center'
                }}>
                  {getFoodTypeDisplay(selectedVendor.foodType).text}
                </div>
              )}
            </div>

            {/* Operating Status */}
            {selectedVendor.operatingHours && (
              <div style={{
                textAlign: 'center',
                marginBottom: '16px',
                padding: '8px 12px',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                border: '1px solid #e9ecef'
              }}>
                <div style={{
                  color: getOperatingStatus(selectedVendor.operatingHours).color,
                  fontSize: '12px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px'
                }}>
                  <span style={{ fontSize: '8px' }}>●</span>
                  {getOperatingStatus(selectedVendor.operatingHours).status}
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div style={{ 
              display: 'flex', 
              gap: '8px', 
              marginBottom: '20px',
              justifyContent: 'center'
            }}>
              {/* Directions Button: open Google Maps directions from user location to vendor */}
              {(() => {
                const vendorCoords = getVendorCoordinates(selectedVendor);
                let directionsUrl = '#';
                if (vendorCoords) {
                  let origin = 'My+Location';
                  if (userLocation && typeof userLocation.latitude === 'number' && typeof userLocation.longitude === 'number') {
                    origin = `${userLocation.latitude},${userLocation.longitude}`;
                  }
                  directionsUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${vendorCoords.latitude},${vendorCoords.longitude}&travelmode=driving`;
                }
                return (
                  <a
                    href={directionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '10px 16px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: '500',
                      fontSize: '13px',
                      transition: 'background-color 0.2s',
                      flex: 1,
                      justifyContent: 'center'
                    }}
                  >
                    📍 Directions
                  </a>
                );
              })()}
              {selectedVendor.contactNumber && (
                <a
                  href={`tel:${selectedVendor.contactNumber}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '10px 16px',
                    backgroundColor: '#28a745',
                    color: 'white',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '500',
                    fontSize: '13px',
                    transition: 'background-color 0.2s',
                    flex: 1,
                    justifyContent: 'center'
                  }}
                >
                  📞 Call
                </a>
              )}
            </div>



            {/* Report Button */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <button
                onClick={() => setShowReportModal(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 16px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '500',
                  fontSize: '12px',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  (e.target as HTMLButtonElement).style.backgroundColor = '#c82333';
                }}
                onMouseLeave={(e) => {
                  (e.target as HTMLButtonElement).style.backgroundColor = '#dc3545';
                }}
              >
                ⚠️ Report Wrong Location
              </button>
            </div>

            {/* Contact Number */}

          {selectedVendor.vendorType !== "tiffin_maker" && (
          <>
            {/* Operating Hours and Days - Compact */}
            <div style={{ 
              marginBottom: '20px', 
              fontSize: '13px', 
              color: '#444',
              backgroundColor: '#f8f9fa',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              <div style={{ marginBottom: '6px' }}>
                <strong>Hours:</strong> {
                  selectedVendor.operatingHours && 
                  selectedVendor.operatingHours.openTime && 
                  selectedVendor.operatingHours.closeTime 
                    ? `${selectedVendor.operatingHours.openTime} - ${selectedVendor.operatingHours.closeTime}` 
                    : 'Not available'
                }
              </div>
              <div>
                <strong>Days:</strong> {
                  selectedVendor.operatingHours && 
                  selectedVendor.operatingHours.days && 
                  selectedVendor.operatingHours.days.length > 0 
                    ? selectedVendor.operatingHours.days
                        .sort((a: number, b: number) => (a === 0 ? 7 : a) - (b === 0 ? 7 : b))
                        .map((day: number) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][day])
                        .join(', ') 
                    : 'Not available'
                }
              </div>
            </div>
            </>
          )}
             {selectedVendor.vendorType === "tiffin_maker" && (
             <div
    style={{
      marginBottom: '20px',
      backgroundColor: '#f8f9fa',
      padding: '14px',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    }}
  >
    <h3
      style={{
        margin: '0 0 12px 0',
        fontSize: '15px',
        color: '#2c3e50'
      }}
    >
      🍱 Meal Timings
    </h3>

    <div style={{ marginBottom: '12px' }}>
  

  {selectedVendor.mealTimings?.breakfast.available && (
    <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f1f3f5'
  }}
>
  <span
    style={{
      color: '#555',
      fontWeight: 500
    }}
  >
    🌅 Breakfast
  </span>

  <span
    style={{
      color: '#2c3e50',
      fontWeight: 600
    }}
  >
    {formatTime(selectedVendor.mealTimings.breakfast.startTime)} – {formatTime(selectedVendor.mealTimings.breakfast.endTime)}
  </span>
</div>
  )}

  {selectedVendor.mealTimings?.lunch.available && (
    <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f1f3f5'
  }}
>
  <span
    style={{
      color: '#555',
      fontWeight: 500
    }}
  >
    ☀️ Lunch
  </span>

  <span
    style={{
      color: '#2c3e50',
      fontWeight: 600
    }}
  >
    {formatTime(selectedVendor.mealTimings.lunch.startTime)} – {formatTime(selectedVendor.mealTimings.lunch.endTime)}
  </span>
  </div>
  )}

  {selectedVendor.mealTimings?.dinner.available && (
    <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f1f3f5'
  }}
>
  <span
    style={{
      color: '#555',
      fontWeight: 500
    }}
  >
    🌙 Dinner
  </span>

  <span
    style={{
      color: '#2c3e50',
      fontWeight: 600
    }}
  >
    {formatTime(selectedVendor.mealTimings.dinner.startTime)} – {formatTime(selectedVendor.mealTimings.dinner.endTime)}
  </span>
</div>
  )}
</div>

    <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '12px',
    marginBottom: '12px'
  }}
>
  <span
    style={{
      fontWeight: 600,
      color: '#2c3e50'
    }}
  >
    🚚 Delivery
  </span>

  <span
    style={{
      color: selectedVendor.deliveryAvailable ? '#28a745' : '#dc3545',
      fontWeight: 500
    }}
  >
    {selectedVendor.deliveryAvailable ? "Available" : "Not Available"}
  </span>
   </div>

    <div>
  <strong>📍 Service Areas:</strong>

  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '10px'
    }}
  >
    {selectedVendor.serviceAreas?.length ? (
      selectedVendor.serviceAreas.map((area, idx) => (
        <span
          key={idx}
          style={{
            backgroundColor: '#eef3f8',
            color: '#2c3e50',
            padding: '5px 10px',
            borderRadius: '16px',
            fontSize: '12px',
            border: '1px solid #d9e2ec'
          }}
        >
          {area
            .split(" ")
            .map(word =>
              word.toLowerCase() === "pdeu"
                ? "PDEU"
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ")}
        </span>
      ))
    ) : (
      <span>Not specified</span>
    )}
  </div>
  </div>
            </div>
            )}


                {selectedVendor.vendorType !== "tiffin_maker" && (
              <>
          
            {/* Menu Options - Compact */}
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ 
                fontSize: '15px', 
                color: '#2c3e50', 
                margin: '0 0 12px 0',
                fontWeight: '600'
              }}>
                Menu
              </h3>
              {(() => {
      const menu =
      (selectedVendor.bestDishes?.length
      ? selectedVendor.bestDishes.map(d => ({
          name: d.name,
          price: d.price
        }))
      : (selectedVendor as any).foodCategories?.map((item: string) => ({
          name: item
        }))) || [];

      return menu.length > 0 ? (
    <div
      style={{
        maxHeight: '200px',
        overflowY: 'auto',
        backgroundColor: '#f8f9fa',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}
    >
      {menu.slice(0, 8).map((dish: any, idx: number) => (
        <div
          key={idx}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px',
            fontSize: '13px',
            color: '#444',
            paddingBottom: '6px',
            borderBottom:
              idx < Math.min(menu.length - 1, 7)
                ? '1px solid #e9ecef'
                : 'none'
          }}
        >
          <span
          style={{
          fontWeight: '500',
          flex: 1,
         paddingRight: '8px'
         }}
        >
         {dish.name}
         </span>

          {dish.price != null ? (
            <span
       style={{
       color: '#28a745',
       fontWeight: '600',
       fontSize: '12px'
       }}
      >
              ₹{dish.price}
            </span>
          ) : null}
        </div>
      ))}
    </div>
      ) : (
    <div
      style={{
        color: '#888',
        fontSize: '13px',
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}
    >
      Menu not available
    </div>
    );
     })()}
            </div>
           </>
          )}

          {selectedVendor.vendorType !== "tiffin_maker" && (
          <>
            {/* Carousel Upload Button */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginTop: '24px',
              marginBottom: '8px'
            }}>
              <button
                onClick={() => {
                  setUploadType('carousel');
                  setShowImageUploadModal(true);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '10px 16px',
                  backgroundColor: '#ff6b6b',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '500',
                  fontSize: '13px',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  (e.target as HTMLButtonElement).style.backgroundColor = '#e55a5a';
                }}
                onMouseLeave={(e) => {
                  (e.target as HTMLButtonElement).style.backgroundColor = '#ff6b6b';
                }}
              >
                📸 Add Laari Images
              </button>
            </div>

            {/* Carousel Images Section */}
            <div style={{ 
              marginTop: 8, 
              backgroundColor: '#f8f9fa', 
              borderRadius: 12, 
              padding: 16, 
              border: '1px solid #e9ecef' 
            }}>
              <h3 style={{ 
                fontSize: '16px', 
                color: '#2c3e50', 
                margin: '0 0 16px 0',
                fontWeight: 600 
              }}>
                Laari Images
              </h3>
              
              {selectedVendor.carouselImages && selectedVendor.carouselImages.length > 0 ? (
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '200px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  backgroundColor: '#fff',
                  border: '1px solid #e9ecef'
                }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                >
                  {/* Carousel Container */}
                  <div 
                    id="carousel-container"
                    style={{
                      display: 'flex',
                      width: `${(selectedVendor.carouselImages?.length || 1) * 100}%`,
                      height: '100%',
                      transition: 'transform 0.5s ease-in-out',
                      transform: `translateX(-${currentImageIndex * (100 / (selectedVendor.carouselImages?.length || 1))}%)`
                    }}
                  >
                    {selectedVendor.carouselImages?.map((imageUrl, index) => (
                      <div 
                        key={index} 
                        style={{
                          width: `${100 / (selectedVendor.carouselImages?.length || 1)}%`,
                          height: '100%',
                          flexShrink: 0,
                          position: 'relative'
                        }}
                      >
                        <img 
                          src={imageUrl} 
                          alt={`Laari image ${index + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            window.open(imageUrl, '_blank');
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      </div>
                    ))}
                  </div>

                  {/* Navigation Arrows */}
                  {selectedVendor.carouselImages && selectedVendor.carouselImages.length > 1 && (
                    <>
                      <button
                        onClick={() => {
                          const newIndex = currentImageIndex - 1;
                          setCurrentImageIndex(newIndex < 0 ? selectedVendor.carouselImages!.length - 1 : newIndex);
                        }}
                        style={{
                          position: 'absolute',
                          left: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'rgba(0, 0, 0, 0.6)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          fontSize: '16px',
                          zIndex: 10,
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.8)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.6)';
                        }}
                      >
                        ‹
                      </button>
                      <button
                        onClick={() => {
                          const newIndex = currentImageIndex + 1;
                          setCurrentImageIndex(newIndex >= selectedVendor.carouselImages!.length ? 0 : newIndex);
                        }}
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'rgba(0, 0, 0, 0.6)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          fontSize: '16px',
                          zIndex: 10,
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.8)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.6)';
                        }}
                      >
                        ›
                      </button>
                    </>
                  )}

                  {/* Dots Indicator */}
                  {selectedVendor.carouselImages && selectedVendor.carouselImages.length > 1 && (
                    <div style={{
                      position: 'absolute',
                      bottom: '8px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: '6px',
                      zIndex: 10
                    }}>
                      {selectedVendor.carouselImages.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentImageIndex(index)}
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            border: 'none',
                            background: index === currentImageIndex ? '#fff' : 'rgba(255, 255, 255, 0.5)',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ 
                  color: '#888', 
                  fontSize: '13px', 
                  textAlign: 'center',
                  padding: 24,
                  backgroundColor: '#fff',
                  borderRadius: 8,
                  border: '1px solid #e9ecef'
                }}>
                  <div style={{ 
                    fontSize: 32, 
                    opacity: 0.3,
                    marginBottom: 8
                  }}>
                    📸
                  </div>
                  <div>No laari images yet</div>
                  <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                    Images will appear here once uploaded
                  </div>
                </div>
              )}
            </div>
              </>
            )}
            {/* Reviews & Ratings - Enhanced Version */}
            <div style={{ 
              marginTop: 24, 
              marginBottom: 24, 
              backgroundColor: '#f8f9fa', 
              borderRadius: 12, 
              padding: 16, 
              border: '1px solid #e9ecef' 
            }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: 16 
              }}>
                <h3 style={{ 
                  fontSize: '16px', 
                  color: '#2c3e50', 
                  margin: 0, 
                  fontWeight: 600 
                }}>
                  Reviews & Ratings
                </h3>
                {reviews.length > 0 && (
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 6,
                    backgroundColor: '#fff',
                    padding: '4px 8px',
                    borderRadius: 8,
                    border: '1px solid #e9ecef'
                  }}>
                    <span style={{ 
                      color: '#f5b50a', 
                      fontSize: 14, 
                      fontWeight: 'bold' 
                    }}>
                      {(reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)}
                    </span>
                    <div style={{ color: '#f5b50a', fontSize: 12 }}>
                      {'★'.repeat(Math.round(reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length))}
                    </div>
                    <span style={{ 
                      color: '#666', 
                      fontSize: 11 
                    }}>
                      ({reviews.length})
                    </span>
                  </div>
                )}
              </div>

              {/* Reviews List */}
              <div style={{ 
                maxHeight: showAllReviews ? '400px' : '200px', 
                overflowY: 'auto',
                marginBottom: 16,
                backgroundColor: '#fff',
                borderRadius: 8,
                border: '1px solid #e9ecef'
              }}>
                {reviews.length === 0 ? (
                  <div style={{ 
                    color: '#888', 
                    fontSize: '13px', 
                    textAlign: 'center',
                    padding: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8
                  }}>
                    <div style={{ 
                      fontSize: 32, 
                      opacity: 0.3 
                    }}>
                      ⭐
                    </div>
                    <div>No reviews yet</div>
                    <div style={{ fontSize: 11, color: '#aaa' }}>
                      Be the first to share your experience!
                    </div>
                  </div>
                ) : (
                  <>
                    {reviews.slice(0, showAllReviews ? reviews.length : 2).map((r, idx) => (
                      <div key={r._id || idx} style={{ 
                        padding: 12,
                        borderBottom: idx < Math.min(reviews.length - 1, showAllReviews ? reviews.length - 1 : 1) ? '1px solid #f0f0f0' : 'none'
                      }}>
                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'flex-start',
                          marginBottom: 6
                        }}>
                          <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 8 
                          }}>
                            <div style={{
                              width: 32,
                              height: 32,
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              fontSize: 12,
                              fontWeight: 'bold'
                            }}>
                              {(r.name || 'A').charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div style={{ 
                                fontWeight: 600, 
                                fontSize: 13,
                                color: '#2c3e50'
                              }}>
                                {r.name}
                              </div>
                              <div style={{ 
                                fontSize: 10, 
                                color: '#888'
                              }}>
                                {r.createdAt ? new Date(r.createdAt).toLocaleDateString('en-US', { 
                                  month: 'short', 
                                  day: 'numeric', 
                                  year: 'numeric' 
                                }) : ''}
                              </div>
                            </div>
                          </div>
                          <div style={{ 
                            backgroundColor: '#f8f9fa',
                            padding: '2px 6px',
                            borderRadius: 4,
                            border: '1px solid #e9ecef'
                          }}>
                            <div style={{ 
                              color: '#f5b50a', 
                              fontSize: 12,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2
                            }}>
                              <span style={{ fontSize: 10 }}>★</span>
                              <span style={{ fontWeight: 600 }}>{r.rating}</span>
                            </div>
                          </div>
                        </div>
                        {r.comment && (
                          <div style={{ 
                            fontSize: 12, 
                            color: '#444',
                            lineHeight: 1.4,
                            marginLeft: 40,
                            fontStyle: 'italic'
                          }}>
                            "{r.comment}"
                          </div>
                        )}
                      </div>
                    ))}
                    {reviews.length > 2 && (
                      <div style={{ 
                        textAlign: 'center', 
                        padding: 8,
                        borderTop: '1px solid #f0f0f0'
                      }}>
                        <button 
                          style={{ 
                            fontSize: 12, 
                            color: '#007bff', 
                            background: 'none', 
                            border: 'none', 
                            cursor: 'pointer',
                            fontWeight: 500,
                            padding: '4px 8px',
                            borderRadius: 4,
                            transition: 'background-color 0.2s'
                          }} 
                          onClick={() => setShowAllReviews(!showAllReviews)}
                          onMouseEnter={e => (e.target as HTMLButtonElement).style.backgroundColor = '#f0f8ff'}
                          onMouseLeave={e => (e.target as HTMLButtonElement).style.backgroundColor = 'transparent'}
                        >
                          {showAllReviews ? '↑ Show less' : `↓ Show all ${reviews.length} reviews`}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Add Review Form */}
              <div style={{ 
                backgroundColor: '#fff',
                borderRadius: 8,
                padding: 16,
                border: '1px solid #e9ecef'
              }}>
                <h4 style={{ 
                  fontSize: 14, 
                  color: '#2c3e50', 
                  margin: '0 0 12px 0',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6
                }}>
                  <span style={{ fontSize: 16 }}>✍️</span>
                  Write a Review
                </h4>
                
                <form onSubmit={handleReviewSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {!auth && (
                    <div style={{ color: '#C80B41', fontSize: 13 }}>You must sign in with Google to submit a review.</div>
                  )}
                  <div style={{ 
                    border: '1px solid #e9ecef', borderRadius: 8, padding: 12, background: '#fff'
                  }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <input 
                          name="name" 
                          value={reviewForm.name} 
                          onChange={handleReviewInput} 
                          placeholder="Your Name" 
                          style={{ 
                            width: '100%', padding: 10, border: '1px solid #e9ecef', borderRadius: 8,
                            outline: 'none', fontSize: 14
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <input 
                          name="email" 
                          value={reviewForm.email} 
                          onChange={handleReviewInput} 
                          placeholder="Your Email" 
                          type="email" 
                          style={{ 
                            width: '100%', padding: 10, border: '1px solid #e9ecef', borderRadius: 8,
                            outline: 'none', fontSize: 14
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: 8,
                      padding: 12,
                      backgroundColor: '#f8f9fa',
                      borderRadius: 6,
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{ 
                        fontSize: 13, 
                        fontWeight: 500, 
                        color: '#2c3e50',
                        marginBottom: 4
                      }}>
                        Rate your experience:
                      </div>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 4,
                        justifyContent: 'center'
                      }}>
                        {[1,2,3,4,5].map(star => (
                          <span 
                            key={star} 
                            style={{ 
                              cursor: 'pointer', 
                              color: reviewForm.rating >= star ? '#f5b50a' : '#ddd', 
                              fontSize: 24,
                              transition: 'color 0.2s, transform 0.1s',
                              userSelect: 'none'
                            }} 
                            onClick={() => handleStarClick(star)}
                            onMouseEnter={e => {
                              (e.target as HTMLSpanElement).style.transform = 'scale(1.1)';
                            }}
                            onMouseLeave={e => {
                              (e.target as HTMLSpanElement).style.transform = 'scale(1)';
                            }}
                          >
                            {reviewForm.rating >= star ? '★' : '☆'}
                          </span>
                        ))}
                      </div>
                      {reviewForm.rating > 0 && (
                        <div style={{ 
                          textAlign: 'center', 
                          fontSize: 11, 
                          color: '#666',
                          marginTop: 4
                        }}>
                          {reviewForm.rating === 1 && "Poor"}
                          {reviewForm.rating === 2 && "Fair"}
                          {reviewForm.rating === 3 && "Good"}
                          {reviewForm.rating === 4 && "Very Good"}
                          {reviewForm.rating === 5 && "Excellent"}
                        </div>
                      )}
                    </div>

                    <div>
                      <textarea 
                        name="comment" 
                        value={reviewForm.comment} 
                        onChange={handleReviewInput} 
                        placeholder="Share your experience (optional)" 
                        style={{ 
                          width: '100%', 
                          padding: '8px 12px', 
                          borderRadius: 6, 
                          border: '1px solid #ddd', 
                          fontSize: 13, 
                          minHeight: 60,
                          resize: 'vertical',
                          fontFamily: 'inherit',
                          transition: 'border-color 0.2s, box-shadow 0.2s',
                          outline: 'none'
                        }} 
                        onFocus={e => {
                          (e.target as HTMLTextAreaElement).style.borderColor = '#007bff';
                          (e.target as HTMLTextAreaElement).style.boxShadow = '0 0 0 2px rgba(0,123,255,0.1)';
                        }}
                        onBlur={e => {
                          (e.target as HTMLTextAreaElement).style.borderColor = '#ddd';
                          (e.target as HTMLTextAreaElement).style.boxShadow = 'none';
                        }}
                      />
                    </div>

                    {reviewError && (
                      <div style={{ 
                        color: '#dc3545', 
                        fontSize: 12, 
                        backgroundColor: '#f8d7da',
                        padding: 8,
                        borderRadius: 4,
                        border: '1px solid #f5c6cb'
                      }}>
                        {reviewError}
                      </div>
                    )}

                    <div style={{ textAlign: 'center' }}>
                      <button 
                        type="submit"
                        disabled={submitting || reviewForm.rating === 0 || !auth}
                        style={{ 
                          display: 'inline-flex', alignItems: 'center', gap: 8,
                          background: submitting ? '#999' : '#2c3e50', color: '#fff', border: 'none',
                          padding: '10px 16px', borderRadius: 8, cursor: submitting ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {submitting ? 'Submitting...' : (
                          <>
                            <span style={{ fontSize: 16 }}>📝</span>
                            Submit Review
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVendorCardVisible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 1999
          }}
          onClick={closeVendorCard}
        />
      )}


      {/* Image Upload Modal */}
      <ImageUploadModal
        isOpen={showImageUploadModal}
        onClose={() => setShowImageUploadModal(false)}
        uploadType={uploadType}
      />

      {/* Report Location Modal */}
      {selectedVendor && (
        <ReportLocationModal
          isOpen={showReportModal}
          onClose={() => setShowReportModal(false)}
          vendorName={selectedVendor.name || selectedVendor.businessName || selectedVendor.vendorName || 'Unknown Vendor'}
          vendorId={selectedVendor._id}
          vendorLocation={getVendorCoordinates(selectedVendor) ? `${getVendorCoordinates(selectedVendor)!.latitude}, ${getVendorCoordinates(selectedVendor)!.longitude}` : 'Location not available'}
          vendorArea={selectedVendor.area || selectedVendor.location?.area || 'Area not specified'}
          userLocation={userLocation ? `${userLocation.latitude}, ${userLocation.longitude}` : 'User location not available'}
        />
      )}

    </div>
  );
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  // const [showAdminPanel, setShowAdminPanel] = useState(false);
  
  const handleLoginSuccess = (token: string) => {
    setToken(token);
    navigate('/admin');
  };
  usePageTracking(); // tracks every route change

  // Removed keyboard shortcut for admin access per requirement

  return (
    <div style={{ height: "100vh", width: "100vw", display: "flex", flexDirection: "column" }}>
      {/* Main content area */}
      <div style={{ flexGrow: 1, position: "relative" }}>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/map" element={<MapDisplay />} />
          <Route path="/admin" element={<AdminPage token={token} />} />
          <Route path="/vendor-upload" element={<VendorUploadPage />} />
          <Route path="/upload" element={<VendorUploadPage />} />
          <Route path="/vendor" element={<VendorUploadPage />} />
          <Route
            path="/register"
            element={<Register onRegisterSuccess={() => {}} />}
          />
          <Route
            path="/login"
            element={<Login onLoginSuccess={handleLoginSuccess} />}
          />
          <Route
            path="/update-profile"
            element={
              token ? (
                <UpdateProfile />
              ) : (
                <Navigate to="/login" state={{ from: location }} replace />
              )
            }
          />
        </Routes>
      </div>
      
      {/* Admin modal removed per requirement; use /admin route instead */}
    </div>
  );
}

export default App;
